import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PricingModel } from '@guryou/core';

const useClassPaymentModels = ({ course }) => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    if (course?.servicesPricing === 'total') {
      setValues([{ value: 'total', label: t('CLASSES.total') }]);
    } else {
      setValues([
        { value: PricingModel.session, label: t('CLASSES.session') },
        { value: PricingModel.custom, label: t('CLASSES.custom') },
        { value: PricingModel.hour, label: t('CLASSES.perHour') },
        { value: PricingModel.total, label: t('CLASSES.total') },
      ]);
    }
  }

  return values;
};

export { useClassPaymentModels };
